import script from "./AlunosPorTurma.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosPorTurma.vue?vue&type=script&setup=true&lang=js"

import "./AlunosPorTurma.vue?vue&type=style&index=0&id=1a61eccd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a61eccd"]])

export default __exports__